
/* ANTSHQ global stock-last ordering v2.
 * Uses CSS order instead of removing/reinserting live product cards.
 * Preserves each product's position relative to other products of the
 * same availability status, without disturbing card elements/events.
 * Requires data-antshq-stock-sort on the direct-card container and
 * data-antshq-in-stock="true|false" on each direct product card.
 * Sorts only the products already present in each listing; Shopify
 * pagination, collection membership, and live inventory refresh are
 * controlled separately.
 */
(function () {
  'use strict';

  var listingSelector = '[data-antshq-stock-sort]';
  var cardSelector = '[data-antshq-in-stock]';
  var queued = false;

  function orderListing(listing) {
    var cards = Array.prototype.filter.call(listing.children, function (child) {
      return child.nodeType === 1 && child.matches(cardSelector);
    });

    if (!cards.length) return;

    // Refuse to alter partially labelled listings.
    var valid = cards.every(function (card) {
      var value = card.getAttribute('data-antshq-in-stock');
      return value === 'true' || value === 'false';
    });
    if (!valid) return;

    cards.forEach(function (card) {
      var order = card.getAttribute('data-antshq-in-stock') === 'true' ? '0' : '1';
      if (card.style.order !== order) card.style.order = order;
    });
  }

  function orderAll() {
    queued = false;
    document.querySelectorAll(listingSelector).forEach(orderListing);
  }

  function scheduleOrder() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(orderAll);
  }

  function initialize() {
    orderAll();

    // Observe new/re-rendered listings and stock-marker changes, not
    // style changes generated by this script. No self-triggering loop.
    var observer = new MutationObserver(function (records) {
      var relevant = records.some(function (record) {
        if (record.type === 'attributes') {
          return record.target.nodeType === 1 &&
            record.target.matches(cardSelector) &&
            !!record.target.closest(listingSelector);
        }

        if (record.target.nodeType === 1 && record.target.closest(listingSelector)) {
          return record.addedNodes.length > 0;
        }
        return Array.prototype.some.call(record.addedNodes, function (node) {
          return node.nodeType === 1 &&
            (node.matches(listingSelector) || !!node.querySelector(listingSelector));
        });
      });
      if (relevant) scheduleOrder();
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-antshq-in-stock']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
